//  eslint-disable-next-line max-len
import React, { useState, useEffect } from 'react';
import { ButtonBase, Box, makeStyles, Typography } from '@material-ui/core';
import { useQuery } from 'react-query';
import ROUTES from 'src/lib/routes';
import useRouter from 'src/hooks/useRouter';
import { suggestions } from 'src/lib/api-client/suggestions';
import { useProductBrowseContext } from 'src/lib/contexts/product-browse-context';
import { storeToLocalStorage } from 'src/lib/utils/store-data-to-local-storage';
import { setPreviousPath } from 'src/lib/utils/setPreviousPath';
import { makeSearchString } from 'src/lib/utils/url-utils';
import { eventMetricsMap, useEventsReporter } from 'src/hooks';
import { useTabsUIStateContext } from 'src/lib/contexts/tabs-ui-state-context';

const useStyles = makeStyles({
    container: {
        padding: '15px 30px',
    },
    querySuggestionRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0px 10px 5px',
        width: '100%',
    },
    querySuggestionText: {
        fontWeight: 300,
        fontSize: '14px',
    },
    icon: {
        width: '15px',
    },
});

type MyCallbackParams = {
    displayText?: string;
    query?: string;
};

export default function AutoCompeleteList() {
    const { push, location, pathname, history, query } = useRouter();
    const {
        fromPath,
        setFromPath,
        searchString,
        setSearchString,
        end,
        goToPage,
        setFilters,
    } = useProductBrowseContext();
    const { analyticsCustomEvent } = useEventsReporter();
    const { setProductLinkInNative } = useTabsUIStateContext();

    const classes = useStyles();
    const { data: items, refetch } = useQuery(['suggestions'], () =>
        suggestions(searchString)
    );

    function onCategoryRowClick(row: any) {
        setFilters([]);
        goToPage({ type: 'search-results', pageDetails: { category: row } });
    }

    const handleRowClick = (item: any) => {
        analyticsCustomEvent(eventMetricsMap.product_search, {
            click_text: 'search performed',
            element_location: 'search bar',
            search_term: searchString,
        });
        if (pathname && pathname.includes(ROUTES.lists)) {
            onCategoryRowClick(item);
        } else {
            setSearchString(item);
            setProductLinkInNative({ src: '', show: false, route: '' });
            storeToLocalStorage('searchHistory', item);
            setFromPath(
                ROUTES.productDetailsPage === location.pathname
                    ? fromPath
                    : location.pathname
            );
            localStorage.setItem(
                'shopSearchNavigation',
                `${ROUTES.productDetailsPage}?searchString=${item}`
            );
            push(
                `${ROUTES.productDetailsPage}?searchString=${item}`,
                setPreviousPath(location, fromPath)
            );
            end();
        }
    };
    useEffect(() => {
        if (searchString !== '') {
            refetch();
        }
    }, [searchString]);

    return (
        <Box className={classes.container}>
            {items?.suggestionGroups?.[0]?.querySuggestions?.map(
                (item: MyCallbackParams) => (
                    <ButtonBase
                        className={classes.querySuggestionRow}
                        onClick={() => handleRowClick(item?.query)}
                    >
                        <Typography className={classes.querySuggestionText}>
                            {item.displayText}
                        </Typography>
                        <img
                            className={classes.icon}
                            src={require('../assets/icons/iconArrow.svg')}
                            alt="search"
                        />
                    </ButtonBase>
                )
            )}
        </Box>
    );
}
